import { useTranslation } from "../hooks/useTranslation";
import { useWordPressPosts } from "../hook/wordpress/posts.wordpress.hook";
import { useMe } from "../hook/partner/authentication/me.partner.hook";
import { useAuthStore } from "../store/auth.store";
import { useLogin } from "../hook/partner/authentication/login.partner.hook";
import { useEffect, useState } from "react";
import { useOpportunitiesStore } from "../store/opportunities.store";
import { useOpportunities } from "../hook/partner/opportunities.partner.hook";
import { PartnerApi } from "../api/partner.api";
import { Pagination } from "../components/List/Pagination";
import { useInvoicesTableStore } from "../store/invoicesTable.store";
import { usePopper } from "react-popper";
import { useOpportunitiesTableStore } from "../store/opportunitiesTable.store";
import { NavLink, useNavigate } from "react-router";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import OpportunityNewForm from "../components/forms/opportunity/OpportunityNewForm";
import OpportunityNewModal from "../components/modals/opportunity/OpportunityNewModal";
import OpportunityRow from "../components/Opportinuty/OpportunityRow";
import OpportunityTable from "../components/Opportinuty/OpportunityTable";
import { FulltextFilter } from "../components/List/FulltextFilter";
import { InvoiceFilter } from "../components/Invoice/InvoiceFilter";
import { OpportunityFilter } from "../components/Opportinuty/OpportunityFilter";
import AnchorData from "../utils/AnchorData";
import { InvoiceFilterActual } from "../components/Invoice/InvoiceFilterActual";
import { OpportunityFilterActual } from "../components/Opportinuty/OpportunityFilterActual";
import { RowSelector } from "../components/List/RowSelector";

function Opportunities() {
  const { t } = useTranslation();
  const proccessStateNamesToIds = (current_state_id_name) => {
    let states = "0,10,25,50,75,90,95,99,100";
    if (
      current_state_id_name.includes("open") ||
      current_state_id_name.includes("order") ||
      current_state_id_name.includes("invoiced")
    ) {
      states = "";

      if (current_state_id_name.includes("open")) {
        states += "10,25,50,75";
      }

      if (current_state_id_name.includes("order")) {
        if (states != "") {
          states += ",";
        }
        states += "90,95,99";
      }

      if (current_state_id_name.includes("invoiced")) {
        if (states != "") {
          states += ",";
        }
        states += "100";
      }
    }
    return states.split(",").map((state) => parseInt(state));
  };

  const opp_filter = JSON.parse(localStorage.getItem("opp_filter"));
  const opp_sorting = JSON.parse(localStorage.getItem("opp_sorting"));

  const anchorData = AnchorData();
  const current_state_id_name = [];
  anchorData?.pageOrder === true && current_state_id_name.push("order");
  anchorData?.pageOpen === true && current_state_id_name.push("open");
  anchorData?.pageInvoiced === true && current_state_id_name.push("invoiced");
  const [filter, setFilter] = useState(
    anchorData
      ? {
          current_state_id_name: current_state_id_name,
          current_state_id: proccessStateNamesToIds(current_state_id_name),
        }
      : {
          ...opp_filter,
          current_state_id_name:
            opp_filter?.current_state_id_name || current_state_id_name,
          current_state_id:
            opp_filter?.current_state_id ||
            proccessStateNamesToIds(current_state_id_name),
        }
  );

  useEffect(() => {
    setPage(1);
  }, [filter]);

  const [page, setPage] = useState(1);

  const [showModalNew, setShowModalNew] = useState(false);

  const opportunitiesMutation = useOpportunities();

  const token = useAuthStore((state) => state.token);
  const opportunities = useOpportunitiesStore((state) => state.opportunities);

  const [sortTable, setSortTable] = useState(
    opp_sorting
      ? opp_sorting
      : {
          sort: "opportunity_id",
          sortDirection: "desc",
        }
  );

  const [rowsSelected, setRows] = useState(10);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  useEffect(() => {
    setPagename(t("opportunities.title"));
    setBreadcrumbs([]);
  }, []);

  useEffect(() => {
    if (token) {
      opportunitiesMutation.mutate({
        token,
        page,
        filter,
        rowsSelected,
        sortTable,
      });
    }
    localStorage.setItem("opp_filter", JSON.stringify(filter));
    localStorage.setItem("opp_sorting", JSON.stringify(sortTable));
  }, [token, page, filter, rowsSelected, sortTable]);

  /* Dynamická tabulka */

  const selectedColumns = useOpportunitiesTableStore((state) => state.selectedColumns);
  const toggleColumn = useOpportunitiesTableStore((state) => state.toggleColumn);
  const getAvailableColumns = useOpportunitiesTableStore((state) => state.getAvailableColumns);
  const awailableColumns = getAvailableColumns();

  return (
    <>
      <div className="card mt-6">
        <div className="card-body border-0 pt-6">
          <div className="d-flex gap-2 justify-content-between">
            <div>
              <div className="card-toolbar">
                <div className="d-flex gap-2 align-items-center mb-2">
                  <FulltextFilter
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        fulltext: e.target.value,
                      })
                    }
                    placeholder={t("opportunities.searchOpportunity")}
                  />
                  <div>
                    <button
                      className="btn btn-success"
                      onClick={() =>
                        PartnerApi.opportunitiesExport({
                          token,
                          rowsSelected,
                          filter,
                        })
                      }
                    >
                      {t("common.exportXlsx")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="card-toolbar">
                <OpportunityNewModal
                  show={showModalNew}
                  handleClose={() => setShowModalNew(false)}
                />

                <OpportunityFilter
                  awailableColumns={awailableColumns}
                  selectedColumns={selectedColumns}
                  toggleColumn={toggleColumn}
                  setFilter={setFilter}
                  filter={filter}
                  setShowModalNew={setShowModalNew}
                  proccessStateNamesToIds={proccessStateNamesToIds}
                />
              </div>
            </div>

            <div
              className="d-flex justify-content-end align-items-center d-none"
              data-kt-customer-table-toolbar="selected"
            >
              <div className="fw-bold me-5">
                <span
                  className="me-2"
                  data-kt-customer-table-select="selected_count"
                >
                  10
                </span>
                Selected
              </div>
              <button
                type="button"
                className="btn btn-danger"
                data-kt-customer-table-select="delete_selected"
              >
                Delete Selected
              </button>
            </div>
          </div>
        </div>

        <div className="card-body pt-0" style={{ overflow: "auto" }}>
          <div className="border-top border-bottom py-3">
            {t("common.totalCount")}: {opportunities?.rows}
          </div>
          <OpportunityFilterActual setFilter={setFilter} filter={filter} />

          <OpportunityTable
            opportunities={opportunities}
            awailableColumns={awailableColumns}
            selectedColumns={selectedColumns}
            checkbox={true}
            sortTable={sortTable}
            setSortTable={setSortTable}
          />
        </div>
      </div>

      {opportunities?.rows > 0 && (
        <>
          <Pagination
            total_pages={opportunities.total_pages}
            rows_per_page={opportunities.rows_per_page}
            page={page}
            setPage={setPage}
          />

          <RowSelector setRows={setRows} />
        </>
      )}
    </>
  );
}

export default Opportunities;
